<template>
    <div class="kstable_popover_array_rows__container">
        <a v-if="hasChilds" href="#" @click.prevent="onOpen" class="no-underline">{{ main }}</a>
        <span v-else>{{ main }}</span>
        <AdaptersOverlayPanel class="item tooltip-target" placement="right-start" ref="overlay">
            <div class="flex flex-column row-gap-1">
                <span v-for="child in childs" class="block text-xs">{{ child }}</span>
            </div>
        </AdaptersOverlayPanel>
    </div>
</template>

<script>
import AdaptersOverlayPanel from "../../adapters/OverlayPanel.vue";

export default {
    name: "KSTablePopoverArrayRows",
    components: {AdaptersOverlayPanel},
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    computed: {
        hasChilds() {
            return this.childs.length > 0;
        },
        main() {
            return  this.rows.shift();
        },
        childs() {
            return this.rows;
        }
    },
    methods: {
        onOpen(e) {
            if (this.$refs.overlay.isOpen) {
                this.$refs.overlay.hide();
                return;
            }
            this.$refs.overlay.show(e);
        }
    }
}
</script>

<style scoped>
.kstable_popover_array_rows__container a {
    border-bottom: 1px dotted var(--keysso-secondary-link-color);
}
</style>
